import { memo } from 'react';
import type { CouponProps } from '@lingoda/ui/fields/Coupon';
import Coupon from '@lingoda/ui/fields/Coupon';
import FormControl from '@lingoda/ui/fields/FormControl';
import FormHelperText from '@lingoda/ui/fields/FormHelperText';
import { ErrorMessage, Field } from '../../utils';
import type { FieldProps } from '../../utils';
import type { FC } from 'react';

type Props = Omit<CouponProps, 'value' | 'onChange' | 'onBlur' | 'onRemove' | 'isValidating'>;

const FormikCouponField: FC<Props> = (props) => (
    <Field {...props}>
        {({
            field,
            form: {
                errors,
                touched,
                setFieldValue,
                setFieldTouched,
                isValidating,
                isSubmitting,
                submitForm,
            },
        }: FieldProps) => {
            const handleChange = (value: string) => {
                void setFieldValue(field.name, value);
            };
            const handleBlur = () => {
                void setFieldTouched(field.name, true);
            };
            const handleRemove = () => {
                // Set field value to empty string without running validations as we'll submit
                // the form right away and that will run validation anyway.
                void setFieldValue(field.name, '', false);
                void submitForm();
            };

            return (
                <FormControl error={!!touched[field.name] && !!errors[field.name]} fullWidth>
                    <Coupon
                        {...props}
                        {...field}
                        isValidating={isValidating || isSubmitting}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onRemove={handleRemove}
                    />
                    <ErrorMessage name={field.name}>
                        {(message) => (
                            <FormHelperText>
                                {typeof message === 'object'
                                    ? Object.values(message).map((msg, index) => (
                                          <p key={`${index}`}>{msg as string}</p>
                                      ))
                                    : message}
                            </FormHelperText>
                        )}
                    </ErrorMessage>
                </FormControl>
            );
        }}
    </Field>
);

export default memo(FormikCouponField);
